import { render, staticRenderFns } from "./BasketButtons.vue?vue&type=template&id=09c4e2b2&scoped=true&"
import script from "./BasketButtons.vue?vue&type=script&lang=js&"
export * from "./BasketButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c4e2b2",
  null
  
)

export default component.exports